<template>
  <main class="antiScam">
    <Loader v-if="loader" />
    <div
      class="antiScam__statistic"
      v-if="!startStatus && !sessionStartInfo && isPermissions.asc_stat"
    >
      <div class="antiScam__statistic__container">
        <div class="antiScam__statistic__tabs">
          <p
            v-for="(item, index) in tabs"
            :class="{ selected: item.selected }"
            @click="switchTab(index)"
          >
            {{ item.name }}
          </p>
        </div>
        <div class="antiScam__statistic__wrapper">
          <AntiScamBotStatistic
            v-if="tabs[0].selected"
            v-for="(botInfo, index) in botStatistic"
            :botStatInfo="botInfo"
            :key="index"
          />
          <AntiScamWorkStatistic
            v-if="tabs[1].selected"
            v-for="(workInfo, index) in workStatistic"
            :workStatInfo="workInfo"
            :key="index"
          />
        </div>
      </div>
    </div>
    <div class="antiScam__firstStep" v-if="!startStatus && !sessionStartInfo">
      <h1 class="antiScam__title">Anti-Scam</h1>
      <button class="antiScam__start" @click="startSession">Начать сессию</button>
    </div>
    <div class="antiScam__secondStep" v-if="sessionStartInfo || activeSession">
      <div class="antiScam__end">
        <div class="antiScam__timer">
          <span
            >{{ timerCheck(timer.hour) }}:{{ timerCheck(timer.minute) }}:{{
              timerCheck(timer.seconds)
            }}</span
          >
        </div>
        <button @click="endSession">Закончить сессию</button>
      </div>
      <div class="antiScam__secondStep__selectedBot" v-if="selectedBot">
        <div class="antiScam__secondStep__selectedBot__addToFriend">
          <a
            :href="`https://www.roblox.com/users/${selectedBot.roblox_id}/profile/`"
            target="_blank"
            class="antiScam__secondStep__selectedBot__add"
          >
            Добавить бота в друзья
          </a>
          <div class="antiScam__secondStep__selectedBot__botInfo">
            <p>
              Bot name: <span>{{ selectedBot.username }}</span>
            </p>
            <p>
              Roblox Id: <span>{{ selectedBot.roblox_id }}</span>
            </p>
          </div>
          <div class="antiScam__secondStep__selectedBot__userName">
            <p v-if="successAddFriend">Запрос отправлен</p>
            <div class="input__wrapper">
              <input typeof="text" placeholder="UserName to add" v-model="adminUserNameRoblox" />
            </div>
            <button @click="addToFriend">Добавить себя в друзья</button>
          </div>
        </div>
        <div class="antiScam__secondStep__selectedBot__verdict">
          <div class="wrapper__checkboxes">
            <div class="checkbox" v-for="(checkbox, index) in verdictTypes">
              <input type="checkbox" :id="checkbox" />
              <label :for="checkbox" @click="selectTypeVerdict(index)">{{ checkbox }}</label>
            </div>
          </div>
          <textarea v-model="verdictComment" placeholder="Комментарий" />
          <button
            :class="{ disable: disableVerdictBtn || !adminUserNameRoblox }"
            @click="sendVerdict"
          >
            Отправить отчет
          </button>
        </div>
      </div>
      <p v-if="verdictSuccess" class="successVerdict">Отчет отправлен</p>
      <div class="antiScam-wrapper__table">
        <table>
          <thead>
            <tr>
              <td>Список ботов</td>
            </tr>
          </thead>
          <tbody>
            <div class="table__loader" v-if="!botList.length">
              <Loader />
            </div>
            <tr
              v-for="(bot, index) in botList"
              @click="selectBot(index)"
              :class="{ block: checkTime(bot.last_check_datetime) }"
            >
              <td>
                <div class="username">
                  User Name:
                  <span>{{ bot.username }}</span>
                </div>
                <div class="lastCheck">
                  Last Check Time:
                  <span>
                    {{
                      bot.last_check_datetime
                        ? getDifferenceTime(bot.last_check_datetime)
                        : 'Не проверен'
                    }}
                  </span>
                </div>
                <div class="trade">
                  Trade count:
                  <span>{{ bot.trades_count }}</span>
                </div>
                <div class="id">
                  Ping time:
                  <span>{{ getDifferenceTime(bot.ping_time) }}</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </main>
</template>

<script>
import './antiScam.scss'
import Loader from '@/components/Loader/Loader.vue'
import cookie from 'vue-cookie'
import AntiScamBotStatistic from '../../components/AntiScamBotStatistic/AntiScamBotStatistic'
import AntiScamWorkStatistic from '../../components/AntiScamWorkStatistic/AntiScamWorkStatistic'

export default {
  name: 'AntiScam',
  components: {
    Loader,
    AntiScamBotStatistic,
    AntiScamWorkStatistic
  },
  data() {
    return {
      startStatus: true,
      loader: true,
      sessionStartInfo: false,
      activeSession: false,
      botList: [],
      selectedBot: '',
      successAddFriend: false,
      adminUserNameRoblox: '',
      verdictTypes: [
        'Скамеров не было',
        'Был 1 скамер',
        'Было несколько скамеров',
        'Не удалось зайти к боту',
        'Не было проблем',
        'Бота не было на месте',
        'Бот не принимает заявку в друзья',
        'У бота много друзей',
        'Нет профиля бота по ссылке',
        'Бота нет в игре'
      ],
      verdictSelectedTypes: [],
      verdictComment: '',
      verdictAdminUserName: '',
      disableVerdictBtn: false,
      verdictSuccess: false,
      timeOutId: null,
      timerId: null,
      startDateTime: '',
      timer: {
        hour: 0,
        minute: 0,
        seconds: 0
      },
      tabs: [
        {
          name: 'Проверки ботов',
          selected: true
        },
        {
          name: 'Сессии сотрудников',
          selected: false
        }
      ],
      botStatistic: [],
      workStatistic: []
    }
  },
  mounted() {
    this.getStartInfo(), this.getStatistic('c')
  },
  destroyed() {
    clearTimeout(this.timeOutId)
  },
  computed: {
    isPermissions() {
      return this.$store.state.permissions
    }
  },
  methods: {
    switchTab(index) {
      if (index === 1 && !this.isPermissions.ass_stat) {
        return
      }
      if (this.tabs[index].selected) {
        return
      }
      if (index === 0) {
        this.getStatistic('c')
      } else {
        this.getStatistic('s')
      }
      for (const tab of this.tabs) {
        tab.selected = false
      }
      this.tabs[index].selected = true
    },
    async getStatistic(info) {
      this.botStatistic = []
      this.workStatistic = []
      await fetch(`https://admin.neuralgeneration.com/api/utils/as${info}-stat`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${this.$store.state.tokens.access}`
        }
      })
        .then((res) => {
          return res.json()
        })
        .then((data) => {
          if (info === 'c') {
            this.botStatistic = data.data
          }
          if (info === 's') {
            this.workStatistic = data.data
          }
        })
    },
    getStartInfo() {
      fetch(`https://admin.neuralgeneration.com/api/utils/as-session`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${this.$store.state.tokens.access}`
        }
      })
        .then((res) => {
          return res.json()
        })
        .then((data) => {
          this.startStatus = data.session
          this.loader = false
          if (data.session) {
            this.activeSession = data.session.active
            this.startDateTime = data.session.start_datetime
            const currentDate = new Date()
            const utc = new Date(currentDate.getTime() + currentDate.getTimezoneOffset() * 60000)
            const arrayTimer = String(
              (utc - new Date(data.session.start_datetime)) / 1000 / 60
            ).split('.')
            if (arrayTimer[0] > 60) {
              this.timer.minute = arrayTimer[0] % 60
              this.timer.hour = Math.floor(arrayTimer[0] / 60)
              this.timer.seconds = String(arrayTimer[1]).slice(0, 2)
            } else {
              this.timer.minute = arrayTimer[0]
              this.timer.seconds = String(arrayTimer[1]).slice(0, 2)
            }
            this.startTimer()
            this.getBotList()
          }
        })
    },
    getDifferenceTime(time) {
      const currentDate = new Date()
      const utc = new Date(currentDate.getTime() + currentDate.getTimezoneOffset() * 60000)
      const arrayTimer = String((utc - new Date(time)) / 1000 / 60).split('.')
      return `${arrayTimer[0]} min ago`
    },
    startSession() {
      this.loader = true
      this.startStatus = true
      fetch(`https://admin.neuralgeneration.com/api/utils/as-session/start`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${this.$store.state.tokens.access}`
        }
      })
        .then((res) => {
          return res.json()
        })
        .then((data) => {
          this.loader = false
          this.sessionStartInfo = data.status
          if (data.status) {
            this.getBotList()
            this.startTimer()
          }
        })
    },
    timerCheck(num) {
      if (num < 10) {
        return `0${num}`
      } else {
        return num
      }
    },
    // parseDate(time) {
    //     const d = new Date(time);
    //
    //     d.setMinutes(d.getMinutes() + -d.getTimezoneOffset());
    //
    //     return d.toLocaleString("ru-RU", {
    //         timeZone: "Europe/Moscow",
    //         weekday: "long",
    //         year: "numeric",
    //         month: "long",
    //         day: "numeric",
    //         hour: "numeric",
    //         minute: "numeric",
    //         second: "numeric",
    //     });
    // },
    checkTime(lastCheckBot) {
      if (!lastCheckBot) {
        return
      }
      const currentDate = new Date()
      const utc = new Date(currentDate.getTime() + currentDate.getTimezoneOffset() * 60000)
      const arrayTimer = String((utc - new Date(lastCheckBot)) / 1000 / 60).split('.')
      if (arrayTimer[0] < 30) {
        return true
      }
    },
    startTimer() {
      this.timerId = setInterval(() => {
        this.timer.seconds++
        if (this.timer.seconds > 60) {
          this.timer.minute++
          this.timer.seconds = 0
        }
        if (this.timer.minute === 60) {
          this.timer.hour++
          this.timer.minute = 0
        }
      }, 1000)
    },
    getBotList() {
      this.botList = []
      if (!this.sessionStartInfo && !this.activeSession && !this.startStatus) {
        return
      }
      fetch(`https://admin.neuralgeneration.com/api/utils/top_bots`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${this.$store.state.tokens.access}`
        }
      })
        .then((res) => {
          return res.json()
        })
        .then((data) => {
          this.botList = data.bots
          this.timeOutId = setTimeout(() => {
            this.getBotList()
          }, 10000)
        })
    },
    selectBot(index) {
      this.selectedBot = this.botList[index]
    },
    addToFriend() {
      if (!this.adminUserNameRoblox) {
        return
      }
      const body = {
        username: this.adminUserNameRoblox,
        bot_id: this.selectedBot.bot_id
      }
      fetch('https://admin.neuralgeneration.com/api/utils/friend', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${cookie.get('token')}`
        },
        body: JSON.stringify(body)
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status) {
            this.verdictAdminUserName = this.adminUserNameRoblox
            this.successAddFriend = true
            setTimeout(() => {
              this.successAddFriend = false
            }, 1500)
          }
        })
    },
    selectTypeVerdict(index) {
      if (this.verdictSelectedTypes.indexOf(String(index + 1)) !== -1) {
        this.verdictSelectedTypes.splice(this.verdictSelectedTypes.indexOf(String(index + 1)), 1)
        return
      }
      this.verdictSelectedTypes.push(String(index + 1))
    },
    sendVerdict() {
      this.verdictAdminUserName = this.adminUserNameRoblox
      this.disableVerdictBtn = true
      const body = {
        verdict: this.verdictSelectedTypes,
        comment: this.verdictComment,
        user_username: this.verdictAdminUserName,
        bot_id: this.selectedBot.bot_id,
        bot_username: this.selectedBot.username,
        bot_roblox_id: this.selectedBot.roblox_id
      }
      fetch('https://admin.neuralgeneration.com/api/utils/as-check', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${cookie.get('token')}`
        },
        body: JSON.stringify(body)
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status) {
            this.selectedBot = ''
            this.verdictAdminUserName = ''
            this.verdictSuccess = true
            this.verdictSelectedTypes = []
            this.verdictComment = ''
            setTimeout(() => {
              this.verdictSuccess = false
            }, 1000)
          }
          this.disableVerdictBtn = false
        })
    },
    endSession() {
      fetch(`https://admin.neuralgeneration.com/api/utils/as-session/finish`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${this.$store.state.tokens.access}`
        }
      })
        .then((res) => {
          return res.json()
        })
        .then((data) => {
          if (data.status) {
            this.selectedBot = ''
            this.sessionStartInfo = false
            this.activeSession = false
            this.startStatus = false
            this.timer.seconds = 0
            this.timer.minute = 0
            this.timer.hour = 0
            clearInterval(this.timerId)
            clearTimeout(this.timeOutId)
          }
        })
    }
  }
}
</script>
